import {Constructor} from "./constructor-wrapper";


/**
 * Apply mixins to a class. Use **@Features** (Decorator) to apply features (mixin) to a class that is based on Generic3DModel
 * @param baseCtor base constructor
 * @param derivedCtors derived feature constructors
 * @Decorator @Features
 * @linkcode frontend/src/app/threejs/decorators/features.decorator.ts
 */
export function applyMixins<T>(baseCtor: any, ...derivedCtors: ( (...args:any[])=> any)[]): Constructor<T> {
    return derivedCtors.reduce((a, o) => o(a), baseCtor)
}
